import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";

export function SortableItem({
    id,
    index,
    preview,
    onRemove,
    fileInputsRef,
    onChange,
}: {
    id: string;
    index: number;
    preview: string | null;
    onRemove: (index: number, e: React.MouseEvent) => void;
    fileInputsRef: React.MutableRefObject<(HTMLInputElement | null)[]>;
    onChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
}) {
    const { attributes, listeners, setNodeRef, transform, transition } =
        useSortable({ id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        border: "2px dashed #ccc",
        borderRadius: "10px",
        height: "120px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        cursor: preview ? "grab" : "pointer",
        position: "relative" as const,
        overflow: "hidden",
        background: "#fafafa",
    };

    const handleClick = (e: React.MouseEvent) => {
        if (!preview) {
            fileInputsRef.current[index]?.click();
        }
    };

    return (
        <div ref={setNodeRef} style={style} onClick={handleClick}>
            {preview ? (
                <>
                    <img
                        src={preview}
                        alt={`preview-${index}`}
                        style={{ width: "100%", height: "100%", objectFit: "cover" }}
                        {...listeners} // drag attivo solo sull'immagine
                        {...attributes}
                    />
                    <button
                        className="hst-close-button-box"
                        type="button"
                        onClick={(e) => onRemove(index, e)}
                    >
                        ✕
                    </button>
                </>
            ) : (
                <span style={{ fontSize: "2rem", color: "#aaa" }}>+</span>
            )}

            <input

                id={`galleryInput-${index}`}
                type="file"
                accept=".jpg, .jpeg, .png"
                ref={(el) => { fileInputsRef.current[index] = el; }}
                style={{ display: "none" }}
                onChange={(e) => onChange(e, index)}
            />
        </div>
    );
}
